import { ActionTypes } from '../constants/AppConstants';
import BaseStore from './BaseStore';

class WidgetAuthStore extends BaseStore {

    getActionHandlers () {
        return {
            [ActionTypes.WIDGET_AUTH_SESSION_STARTED]: this.handleSessionStarted
        };
    }

    isWidgetAuth () {
        return this.state.get('widgetAuth');
    }

    handleSessionStarted () {
        const state = this.state.merge({
            widgetAuth: true
        });
        this.setState(state);
    }

}

const instance = new WidgetAuthStore();

export default instance;
